"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../helpers");
function ListEntry(_a) {
    var openChatId = _a.openChatId, chat = _a.chat, isLast = _a.isLast, handleSwitchOpenChatId = _a.handleSwitchOpenChatId;
    var isActive = openChatId === chat.id;
    var latestRequest = chat.requests[chat.requests.length - 1];
    var unreadMessages = chat.last_message.sender_type !== chat.user_role && !chat.last_message.read;
    var lastMessageHasFiles = chat.last_message.files.length > 0;
    var messagePreview = chat.last_message.message === null || chat.last_message.message === ""
        ? window.Translator.trans("chat.file", {}, "js")
        : chat.last_message.type === "HTML"
            ? stripHtml(chat.last_message.message)
            : chat.last_message.message;
    function stripHtml(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        return doc.body.textContent || "";
    }
    return (react_1.default.createElement("li", { className: "chat-list-item border-top border-start px-2 p-3".concat(isActive ? " active" : "").concat(isLast ? " border-bottom" : ""), "data-chat-id": chat.id, onClick: function (e) { return handleSwitchOpenChatId(e); } },
        react_1.default.createElement("div", { className: "d-flex justify-content-between gap-1" },
            react_1.default.createElement("div", { className: "d-flex gap-1" },
                react_1.default.createElement("span", { className: "".concat(unreadMessages ? "strong" : "") }, latestRequest ? (latestRequest.name + " " + latestRequest.surname) : (react_1.default.createElement("span", { className: "italic" },
                    "(",
                    window.Translator.trans("chat.unknown", {}, "js"),
                    ")"))),
                react_1.default.createElement("span", { className: "text small gray italic d-flex gap-1" },
                    chat.landlord_hide && (react_1.default.createElement(react_1.default.Fragment, null,
                        "\u2022",
                        react_1.default.createElement("span", null, window.Translator.trans("chat.filter.hidden", {}, "js")))),
                    chat.tenant_blocked && (react_1.default.createElement(react_1.default.Fragment, null,
                        "\u2022",
                        react_1.default.createElement("span", null, window.Translator.trans("chat.filter.blocked", {}, "js")))))),
            react_1.default.createElement("span", { className: "text small gray nw ".concat(unreadMessages ? "strong" : "") }, (0, helpers_1.formatTimeChatList)(chat.last_message.created))),
        react_1.default.createElement("div", { className: "d-flex justify-content-between".concat(unreadMessages ? " pe-5" : "") },
            react_1.default.createElement("span", { className: "text-truncate text small gray".concat(unreadMessages ? " strong" : ""), title: messagePreview },
                lastMessageHasFiles && (react_1.default.createElement("svg", { className: "icon mb-0 gray", width: "16", height: "16" },
                    react_1.default.createElement("use", { href: "#paper-clip" }))),
                messagePreview),
            unreadMessages && (react_1.default.createElement("span", { className: "new" },
                react_1.default.createElement("em", { className: "new--ribbon" }, window.Translator.trans("chat.new", {}, "js")))))));
}
exports.default = ListEntry;
